import { useAuth } from "@clerk/clerk-react";
import { AlertContext } from "contexts/Alert";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";

import ConfirmDialog from "components/Dialogs/ConfirmDialog";
import { fetcherAuth } from "utils/api";

interface Props {
  openIsDirtyWarning: boolean;
  setOpenIsDirtyWarning: (open: boolean) => void;
  setIsDirty: (isDirty: boolean) => void;
  confirmedClose: () => void;
  isUserFirstTemplate: boolean;
}
const UnsavedChanges = ({
  openIsDirtyWarning,
  setOpenIsDirtyWarning,
  setIsDirty,
  confirmedClose,
  isUserFirstTemplate,
}: Props) => {
  const { setErrorAlert } = useContext(AlertContext);
  const { getToken } = useAuth();
  const { currentOrg } = useContext(OrganizationUserContext);

  const clearTemplateSequence = async () => {
    try {
      await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg?.id}/templates/from-onboarding`,
        "DELETE",
      );
    } catch (error) {
      setErrorAlert(error);
    }
  };

  return (
    <ConfirmDialog
      header={`Discard changes?`}
      subheader={`You're navigating away from a template that is being edited. Do you want to discard these changes?`}
      open={openIsDirtyWarning}
      handleClose={() => {
        setOpenIsDirtyWarning(false);
      }}
      handleConfirm={() => {
        setIsDirty(false);
        setOpenIsDirtyWarning(false);
        confirmedClose();
        if (isUserFirstTemplate) {
          clearTemplateSequence();
        }
      }}
    />
  );
};

export default UnsavedChanges;
